import React from 'react';
type SectionHeadingProps = {
  title: React.ReactNode;
  sub?: React.ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  title,
  sub,
  tone = 'light'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className="mx-auto max-w-3xl text-center" data-id="element-62" data-mp="3f2wynq2tn7yt">
      <h2 className={`font-serif text-[32px] font-black leading-[1.12] md:text-5xl ${dark ? 'text-white' : 'text-navy'}`} data-id="element-63" data-mp="3jzndka2w3xin">
        {title}
      </h2>
      {sub && <p className={`mt-4 text-lg leading-relaxed md:text-xl ${dark ? 'text-sky-light' : 'text-muted'}`} data-id="element-64" data-mp="bmpvdkobjcqk">{sub}</p>}
    </div>;
}